/* eslint-disable */
import axios from 'axios'
import config from '@assets/config.json' // api 请求json
import qs from 'qs'
import { Message, Modal } from 'view-design'
import router from '@/router/router.js'
// 通用 Module
const state = {
  company: null, // 公司信息
  exhibition: null, // 展会信息
  joinInfo: null // 参展信息,提会刊时用的joinId
}
const mutations = {
  setCompany(state, data) {
    state.company = data
  },
  setExhibition(state, data) {
    state.exhibition = data
  },
  setJoinInfo(state, data) {
    state.joinInfo = data
  }
}
const getters = {
  getCompany: (state) => {
    return state.company
  },
  getExhibition: (state) => {
    return state.exhibition
  },
  getJoinInfo: (state) => {
    return state.joinInfo
  }
}
const actions = {
  sendLoginSms({ rootState }, req) {
    // 获取短信验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/SendLoginSms`,
          req,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  validLoginCode({ rootState }, req) {
    // 获取短信验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ValidLoginCode`,
          req,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getUser({ rootState, commit }) {
    // 获取短信验证码
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.auth}/api/account/GetInfo`, rootState.tokenHeaders)
        .then((data) => {
          if (data.data) {
            commit('setUser', data.data, { root: true })
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  checkUserName({ rootState }, req) {
    // 检查是否有注册用户
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/Account/CheckUserName`,
          req,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getMsgCode({}, phone) {
    // 获取短信验证码
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/VerCode/sms/send`, {
          Phone: phone
        })
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success('验证码已发送')
            } else {
              Message.success('验证码发送失败')
            }
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  validateMsgCode({}, opt) {
    // 效验短信验证码
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/VerCode/sms/validate`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getImgCode({}) {
    // 获取图片验证码
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/VerCode/imgCode`)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  validateImgCode({}, opt) {
    // 效验图片验证码
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/VerCode/imgCode/validate`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getJoinInfo({ rootState }, opt) {
    // 判断是否参展
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/join/GetJoin`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getHomeMsg({ rootState }, id) {
    // 判断是否参展
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/company/GetCompanyCount?joinid=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getToken({ rootState, commit }, opt) {
    // 获取token
    return new Promise((resolve, reject) => {
      console.log(111, rootState.formHeaders)
      axios
        .post(
          `${config.api.auth}/connect/token`,
          qs.stringify(opt),
          rootState.formHeaders
        )
        .then((data) => {
          if (data.data) {
            commit('setAuth', data.data, { root: true })
            resolve(data.data)
          }
        })
        .catch((err) => {
          let req = err.response
          if (req && req.data && req.data.error_description) {
            if (req.data.code === 4002) {
              Message.error({
                content: '登录身份有误，请重新确认',
                duration: 2
              })
            } else {
              Message.error({
                content: req.data.error_description,
                duration: 2
              })
            }
          }
          resolve(null)
        })
    })
  },
  getCompany({ rootState }, id) {
    // 根据用户id获取公司信息
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/company/GetByUserId?userId=${id}`,
          rootState.header
        )
        .then((data) => {
          resolve(data.data)
        })
    })
  },
  getCompanyById({ rootState }, id) {
    // 根据用户id获取公司信息
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/company?id=${id}`, rootState.header)
        .then((data) => {
          resolve(data.data)
        })
    })
  },
  getExIdByUserId({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/Join/GetJoinRelevant?userid=${id}`,
          rootState.header
        )
        .then((data) => {
          resolve(data.data)
        })
    })
  },
  exit({ commit, rootState }) {
    let url = ''
    if (rootState.role === 1) {
      url = '/host/login/alogin'
    } else if (rootState.role === 2) {
      url = '/exhibitionEn/login/alogin'
    } else {
      url = '/exhibition/login/alogin'
    }
    commit('setLogin', false, { root: true })
    commit('setUser', null, { root: true })
    commit('setAuth', null, { root: true })
    commit('setToken', null, { root: true })
    localStorage.clear()
    location.href = url
    // Modal.confirm({
    //   title: "确认",
    //   content: "<p>是否退出 ？</p>",
    //   onOk: () => {

    //   },
    //   onCancel: () => { }
    // });
  },
  changePasswordByOld({ rootState }, opt) {
    // 通过原密码改新密码
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.auth}/api/account/resetpassword`,
          opt,
          rootState.header
        )
        .then((data) => {
          resolve(data.data)
        })
    })
  },

  // 公司认证信息
  getCompLicense({ rootState, commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/CompLicense/GetByCompId?compId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  addCompLicense({ rootState }, opt) {
    // 添加认证信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/CompLicense`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  editCompLicenseAuditStatus({ rootState }, id) {
    // 修改认证信息的审核状态
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/CompLicense/SetAuditStatus`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  editCompLicense({ rootState }, opt) {
    // 修改认证信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/CompLicense`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  // 公司发票信息
  getCompInvoice({ rootState, commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/CompInvoice/GetByCompId?compId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  addCompInvoice({ rootState }, opt) {
    // 添加认证信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/CompInvoice`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  editCompInvoice({ rootState }, opt) {
    // 修改认证信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/CompInvoice`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  GetExhibitionByCompany({ rootState }, id) {
    // 获取公司展会信息
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/join/GetExhibitionByCompany?compId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  SwitchDefaultJoin({ rootState }, opt) {
    // 设置公司默认展会
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/join/SwitchDefaultJoin`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
